import { render, staticRenderFns } from "./IntegracoesV1.vue?vue&type=template&id=6f92219c"
import script from "./IntegracoesV1.vue?vue&type=script&lang=ts"
export * from "./IntegracoesV1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports